import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, KeyValues5, LocalService, NumericConfig, Status } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-billing-adjust-formula',
  templateUrl: './billing-adjust-formula.component.html',
  styleUrl: './billing-adjust-formula.component.scss'
})
export class BillingAdjustFormulaComponent {
  lstSectionConfigKeys: string[] = ["seller"];

  @Input() businessId: string;
  @Input() countryCode: string;

  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  items: KeyValues5[];
  numericConfig: NumericConfig = { maxDigits: 4, isStartWithZeroAllowed: true, isDecimalAllowed: true } as NumericConfig;
  numericConfigSetValue: NumericConfig = { maxDigits: 5, isStartWithZeroAllowed: true, isDecimalAllowed: true } as NumericConfig;

  constructor(public localService: LocalService, private sellerManagementService: SellerManagementService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpen) {
      this.onLoad();
    }
  }

  onLoad() {
    this.sellerManagementService.getBillingAdjustmentFormulas(this.businessId).subscribe(result => {
      this.items = result;
      this.onInitiateNewItem();
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onDismiss();
      } break;
      case 2: {
        this.onSave(key);
      } break;
    }
  }

  onSave(key?: string) {
    if (this.onValidate(key)) {
      const item = this.items.find(x => x.key == key);
      this.sellerManagementService.saveBillingAdjustmentFormula(item).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Success: {
            this.onLoad();
          } break;
        }
      });
    }
  }

  onValidate(key?: string) {
    let rtn = true;
    const item = this.items.find(x => x.key == key);
    if (item) {
      if (item.v2 && item.v3 && (parseFloat(item.v2) >= parseFloat(item.v3))) {
        this.localService.showInformationByStatus(Status.RangeNotAllowed, true);
        rtn = false;
      } else if ((!item.v2 || parseFloat(item.v2) <= 0)
        || (!item.v3 || parseFloat(item.v3) <= 0)) {
        this.localService.showInformationByStatus(Status.DataRequired, true);
        rtn = false;
      }
    } else {
      rtn = false;
    }
    return rtn;
  }

  onDismiss() {
    this.isOpen = false;
    this.onClose.emit(this.isOpen);
  }

  onInitiateNewItem() {
    if (!this.items || this.items.length == 0) {
      this.items = [];
      this.items.push({
        v1: this.businessId,
        v2: '1',
        v3: '99',
        v4: '0'
      } as KeyValues5);
    } else {
      this.items.push({
        v1: this.businessId,
      } as KeyValues5);
    }
  }

  onActiveInactiveStatus(strId: string) {
    this.sellerManagementService.activeInactiveStatus(strId, ActiveInactiveFor.BillingAdjustmentFormula).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.items.find(x => x.key == strId);
        updatedItem.v5 = result.id;
      }
    });
  }
}
